import { FC } from "react";
import { Organisation } from "@prisma/client";

interface Props {
  organisation: Organisation;
}

export const OrganizationJsonLd: FC<Props> = ({ organisation }) => {
  // Return early if no organisation.
  if (!organisation) return null;

  // Put it all together.
  const jsonLD = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: organisation.name,
    url: `${organisation.webUrl}`,
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLD),
      }}
    />
  );
};
